const awardLevels = [
  { description: "Classroom", value: 0x1 },
  { description: "School", value: 0x2 },
  { description: "District", value: 0x4 }
];

export { awardLevels };
